import http from 'utlis/http';

const baseURL = `${process.env.REACT_APP_BASE_URL}/api/v1`;

export default class ProTierService {
  static async createCheckoutSession() {
    const resp = await http.post(`${baseURL}/user/billing/checkout-session/`);

    return resp.data;
  }

  static async getSubscriptionInfo() {
    const resp = await http.get(`${baseURL}/user/reviewer/subscription_info/`);

    return resp.data;
  }

  static async getCustomerPortal(returnUrl) {
    const requestBody = {
      return_url: returnUrl,
    };

    const resp = await http.post(`${baseURL}/user/billing/customer-portal/`, requestBody);

    return resp.data;
  }
}
